import _createClass from "/app/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _classCallCheck from "/app/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _callSuper from "/app/node_modules/@babel/runtime/helpers/esm/callSuper.js";
import _inherits from "/app/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _defineProperty from "/app/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import "core-js/modules/es.array.concat.js";
import { __decorate } from "tslib";
import { Vue } from 'vue-class-component';
import { Prop } from 'vue-property-decorator';
var SidePanel = /*#__PURE__*/function (_Vue) {
  function SidePanel() {
    var _this;
    _classCallCheck(this, SidePanel);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, SidePanel, [].concat(args));
    _defineProperty(_this, "visible", void 0);
    _defineProperty(_this, "title", void 0);
    return _this;
  }
  _inherits(SidePanel, _Vue);
  return _createClass(SidePanel);
}(Vue);
export { SidePanel as default };
__decorate([Prop({
  default: false
})], SidePanel.prototype, "visible", void 0);
__decorate([Prop({
  default: ''
})], SidePanel.prototype, "title", void 0);